<template>
  <Dialog
    v-model:visible="showModal"
    class="w-3/5 bg-white shadow rounded-xl"
    :modal="true"
  >
    <template #header>
      <div class="w-full text-gray-900 font-semibold">{{lang['components']['Dialog']['OrderDetailDialog']['order_detail_title_text']}}</div>
    </template>
    <div class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pt-3 rounded-bl-lg rounded-br-lg">
      <table class="min-w-full">
        <thead>
          <tr>
            <th class="px-2 py-3 border-b border-gray-500 text-left text-sm text-gray-900">
              {{lang['components']['Dialog']['OrderDetailDialog']['order_detail_table_field_1']}}
              </th>
            <th class="px-2 py-3 border-b border-gray-500 text-left text-sm text-gray-900">
              {{lang['components']['Dialog']['OrderDetailDialog']['order_detail_table_field_2']}}
            </th>
          </tr>
        </thead>
        <tbody class="bg-white record-table">
          <tr class="hover:bg-gray-50" v-for="(item, index) in list" :key="index">
            <td class="px-2 py-2 whitespace-no-wrap border-b border-gray-500">
              <span class="text-sm text-gray-800">{{ item.field }}</span>
            </td>
            <td class="px-2 py-2 whitespace-no-wrap border-b border-gray-500">
              <span class="text-sm text-gray-800">{{ item.content }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <template #footer>
      <div class="w-full text-right py-4 border-t border-gray-400">
        <button
          class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-400 transition duration-500 ease-in-out mt-32 border-blue-400 border-2"
          @click="showModal=false">{{lang['components']['Dialog']['OrderDetailDialog']['order_detail_cancel_button_text']}}</button>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
  name: "OrderDetailDialog",
  components: {
    Dialog,
    DataTable,
    Column
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    lang: {
      type: Object
    },
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function(value) {
        this.$emit("update:show", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep() {
  .p-datatable {
    tr button {
      opacity: 0;
    }

    tr {
      &:hover {
        button {
          opacity: 1;
        }
      }
    }
  }

  .p-datatable .p-datatable-thead > tr > th {
    background: transparent !important;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(107, 114, 128, var(--tw-border-opacity));
  }

  .p-datatable .p-datatable-tbody > tr > td {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(107, 114, 128, var(--tw-border-opacity));
  }

  .p-datatable .p-datatable-tbody > tr:hover {
    --tw-bg-opacity: 1;
    background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
  }
}
</style>
